import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import Modal from "react-bootstrap/Modal";
import { GlobalContext } from "../../Utils/GlobalContext";
import { Salvar, Cancelar } from "../Generals/buttons";


const TiposPagamentoModal = ({
  show,
  handleClose,
  tipoPagamento,
  fetchTiposPagamento,
}) => {
  const [descricao, setDescricao] = useState("");
  const [situacao, setSituacao] = useState("A");
  const [error, setError] = useState(null);
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  useEffect(() => {
    if (!show) return;
    setError(null);
    if (tipoPagamento) {
      setDescricao(tipoPagamento.descricao || "");
      setSituacao(tipoPagamento.situacao || "A");
    } else {
      setDescricao("");
      setSituacao("A");
    }
  }, [show, tipoPagamento]);

  const handleSave = async () => {
    setError(null);
    const descricaoTrim = (descricao || "").trim();
    if (!descricaoTrim) {
      setError("Descrição é obrigatória.");
      return;
    }
    const tipoPagamentoData = {
      descricao: descricaoTrim,
      situacao,
    };

    try {
      let resultado = null;
      if (tipoPagamento) {
        await api.put(
          `${BASE_URL}/api/tiposPagamento/EditarTiposPagamento/${tipoPagamento.id}`,
          tipoPagamentoData
        ); // Editar
      } else {
        const res = await api.post(
          `${BASE_URL}/api/tiposPagamento/InserirTiposPagamento/${entidadeID}`,
          tipoPagamentoData
        ); // Inserir
        resultado = res.data?.data || res.data || null;
      }
      fetchTiposPagamento();
      handleClose(resultado);
    } catch (err) {
      console.error("Erro ao salvar tipo de pagamento:", err);
      setError(err.response?.data?.message || "Erro ao salvar. Tente novamente.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          {tipoPagamento ? "Tipo de Pagamento" : "Adicionar Tipo de Pagamento"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <Form>
          <Form.Group controlId="formDescricao">
            <Form.Label>Descrição <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Informe a descrição"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formSituacao" className="mt-3">
            <Form.Label>Situação</Form.Label>
            <Form.Select
              value={situacao}
              onChange={(e) => setSituacao(e.target.value)}
            >
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} />
          <Salvar onClick={handleSave} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TiposPagamentoModal;
